import { AnchorIds, TourIds, TourSignal } from "../TourTypes";
import { ArrowPosition } from "../StickyNote";

const FIND_TOUR_AGAIN_TOUR = {
  id: TourIds.FIND_TOUR_AGAIN,
  steps: [
    {
      id: "1",
      stickies: [
        {
          content: "If you want to take the tour later, you can find it in the help menu.",
          offsetX: -250,
          offsetY: 20,
          anchorId: AnchorIds.HELP_ICON,
          arrowPosition: ArrowPosition.TopRight,
          rotation: -5,
        },
      ],
      listeningFor: [TourSignal.GLOBAL_CLICK],
    },
  ],
};

export { FIND_TOUR_AGAIN_TOUR };
